export const DUA_PART_SEPERATOR = ':'

export const getDuaPageAndPartKey = (key: string | number | null | undefined) => {
  if (key === null || key === undefined || key === '' || key === 0) {
    return [null, null] as const
  }
  const [page, partKey] = String(key).split(DUA_PART_SEPERATOR)
  return [Number(page), partKey ? Number(partKey) : null] as const
}
